'use client';
import { jsx } from 'react/jsx-runtime';
import { Slot } from '@radix-ui/react-slot';
import cl from 'clsx/lite';
import { forwardRef } from 'react';

/**
 * Use `ValidationMessage` to display validation text
 *
 * @example
 * <ValidationMessage>This is a danger validation message</ValidationMessage>
 */
const ValidationMessage = forwardRef(function ValidationMessage({ className, asChild, ...rest }, ref) {
    const Component = asChild ? Slot : 'p';
    return (jsx(Component, { className: cl('ds-validation-message', className), "data-field": 'validation', ref: ref, ...rest }));
});

export { ValidationMessage };
